import React from "react";
import { Box } from "@material-ui/core";
import Page from "src/component/Page";
import Banner from "./Banner";
import LivePrice from "./LivePrice";
import Transaction from "./Transaction";
import Technology from "./Technology";
import Fiero from "./Fiero";
import Globe from "./Globe";
import Roadmap from "./Roadmap";
// import RoadMapContent from "./RoadMapContent";
import News from "./News";
import NftCollection from "./NftCollection";
import Crypto from "./Crypto";
function Home(props) {
  return (
    <Page title="Fieres">
      <Box>
        <Banner />
      </Box>

      {/* <Box>
        <LivePrice />
      </Box> */}
      <Box>
        <Globe />
      </Box>
      <Box>
        <Fiero />
      </Box>
      <Box>
        <NftCollection />
      </Box>
      <Box className="purplecircleBox rotate"></Box>
      <Box>
        <Transaction />
      </Box>
      {/* <Box>
        <Roadmap />
      </Box> */}
      {/* <Box>
        <RoadMapContent />
      </Box> */}
      <Box>
        <Technology />
      </Box>
      <Box>
        <News />
      </Box>
      <Box>
        <Crypto />
      </Box>
    </Page>
  );
}

export default Home;
